import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["propertyId"];
import { applySnapshot, getSnapshot, types } from 'mobx-state-tree';
const PaymentMethod = types.model('PaymentMethod', {
  brand: types.string,
  id: types.string,
  isVerified: types.boolean,
  isDefault: types.boolean,
  last4: types.string,
  paymentMethodType: types.maybeNull(types.string),
  assignedPropertyIds: types.maybeNull(types.array(types.string)),
  verificationDaysLeft: types.maybeNull(types.number),
  verificationUrl: types.maybeNull(types.string),
  isFailed: types.optional(types.boolean, false)
});
const PropertyPaymentMethod = types.model('PropertyPaymentMethod', {
  paymentMethodId: types.optional(types.maybeNull(types.string), ''),
  isInvoicePaymentFailed: types.optional(types.maybeNull(types.boolean), false),
  brand: types.optional(types.maybeNull(types.string), ''),
  last4: types.optional(types.maybeNull(types.string), '')
});
export const PaymentSetupModel = types.model({
  paymentMethodsValues: types.optional(types.array(PaymentMethod), []),
  propertyPaymentMethod: types.optional(types.maybeNull(types.string), ''),
  propertyPaymentMethodData: types.optional(PropertyPaymentMethod, {})
}).actions(store => {
  let afterLoadState;
  return {
    initAfterLoadState() {
      try {
        afterLoadState = getSnapshot(store);
      } catch (error) {
        console.error('STORE ERROR > ', error);
      }
    },
    applyAfterLoadState() {
      try {
        applySnapshot(store, afterLoadState);
      } catch (error) {
        console.error('STORE ERROR > ', error);
      }
    },
    setPaymentMethodsAfterLoad(data) {
      try {
        store.paymentMethodsValues = data.response;
      } catch (error) {
        console.error('STORE ERROR > ', error);
      }
    },
    setPropertyPaymentMethodData(data) {
      try {
        const propertyId = data.propertyId,
          rest = _objectWithoutProperties(data, _excluded);
        store.propertyPaymentMethodData = rest;
      } catch (error) {
        console.error('STORE ERROR > ', error);
      }
    },
    setPropertyPaymentMethod(data) {
      try {
        store.propertyPaymentMethod = data;
      } catch (error) {
        console.error('STORE ERROR > ', error);
      }
    }
  };
});